import React from 'react';

interface HeaderNavProps {
    className?: string;
}

export const HeaderNav: React.FC<HeaderNavProps> = ({ className = '' }) => {
    return (
        <header className={`bg-white shadow-sm sticky top-0 z-50 ${className}`}>
            <div className="container mx-auto px-4">
                <div className="flex items-center justify-between h-16 md:h-20">
                    {/* Logo and Brand */}
                    <div className="flex items-center">
                        <a
                            href="https://bibihelp.com"
                            className="text-2xl md:text-3xl font-bold text-bibi-blue hover:text-bibi-blue/80 transition-colors duration-200"
                        >
                            BiBi
                        </a>
                        <div className="hidden md:block ml-3 text-sm text-gray-600 border-l border-gray-300 pl-3">
                            Supporting Seniors in the Homes They Love
                        </div>
                    </div>

                    {/* Service Area - Desktop/Tablet Only */}
                    <div className="hidden sm:flex items-center text-sm text-gray-600">
                        <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        Serving Wichita Metro
                    </div>

                    {/* Mobile Service Area - Top Right */}
                    <div className="sm:hidden flex items-center text-sm text-gray-600">
                        <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        Serving Wichita Metro
                    </div>
                </div>
            </div>
        </header>
    );
};
